import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid2,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import * as yup from "yup";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
});

const ChangePassword = () => {
  const [passwordData, setPasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const Schema = yup.object({
    current_password: yup.string().required("This is required field."),
    new_password: yup.string().required("This is required field."),
    confirm_password: yup.string().required("This is required field."),
  });

  const {
    dirty,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    touched,
    setFieldValue,
  } = useFormik({
    initialValues: passwordData,
    enableReinitialize: true,
    onSubmit: (data) => {
      console.log("data", data);
    },
    validationSchema: Schema,
  });

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.Settings || {},
  }));

  return (
    <Grid2 sx={styles}>
      <Grid2
        container
        spacing={2}
        columns={{ xl: 12, lg: 12, md: 6, sm: 6, xs: 6 }}
      >
        <Grid2 size={6}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Box display={"flex"} flexDirection={"column"} gap="15px">
              <Typography fontWeight={500} variant="title">
                {Translation?.UpdatePassword}
              </Typography>
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.CurrentPassword}
                </FormLabel>
                <TextField
                  error={touched.current_password && errors.current_password}
                  helperText={
                    touched.current_password &&
                    errors.current_password &&
                    errors.current_password
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="current_password"
                  size="small"
                  placeholder="Enter Your Current Password"
                />
              </FormControl>
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.NewPassword}
                </FormLabel>
                <TextField
                  error={touched.new_password && errors.new_password}
                  helperText={
                    touched.new_password &&
                    errors.new_password &&
                    errors.new_password
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="new_password"
                  size="small"
                  placeholder="Enter Your New Password"
                />
              </FormControl>{" "}
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.ConfirmPassword}
                </FormLabel>
                <TextField
                  error={touched.confirm_password && errors.confirm_password}
                  helperText={
                    touched.confirm_password &&
                    errors.confirm_password &&
                    errors.confirm_password
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="confirm_password"
                  size="small"
                  placeholder="Enter Your Confirm Password"
                />
              </FormControl>
              <Button
                type="submit"
                sx={{ width: "fit-content" }}
                variant="outlined"
              >
                {Translation?.RequestOTP}
              </Button>
            </Box>
          </form>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default ChangePassword;
